import React from 'react';
import Grid from '@material-ui/core/Grid';
import {
  ActiveInventoryStatsSummary,
  ActivityTrends,
  CallsTrends,
  FinancialStatsSummary,
  GoalsProgressInTime,
  InMailsTrends,
  LastDateStatsSummary,
  NotConnectedCallsTrends,
  NotConnectedHourlyCallTrends,
  NotConnectedPhoneTimeTrends,
  PeopleReachedTrends,
  PhoneTimeTrends,
  PilMap,
  PlacementsTrends,
  ProductionCashInByMonth,
  ProductivityStatsSummary,
  SendoutsTrends,
  WeeklyActivityStatsSummary,
  WeeklyInventoryGrowthStatsSummary,
  WeeklyProductivityStatsSummary
} from 'features/command-center';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { FeatureFlags } from 'UI/constants/featureFlags';

export const RecruiterOverview = ({ recruiterId }) => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();

  const canDoDrillDown = checkIfFeatureFlagEnabled(FeatureFlags.CommandCenterDrillDown);
  const requestParams = {
    recruiter: recruiterId.toUpperCase(),
    ...(canDoDrillDown && { version: 1 })
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <PilMap requestParams={requestParams} />
      </Grid>

      <Grid item xs={12}>
        <ActiveInventoryStatsSummary requestParams={requestParams} hasDrillDown={canDoDrillDown} />
      </Grid>

      <Grid item xs={12}>
        <FinancialStatsSummary requestParams={requestParams} />
      </Grid>

      <Grid item xs={12}>
        <ProductivityStatsSummary requestParams={requestParams} hasDrillDown={canDoDrillDown} />
      </Grid>

      <Grid item xs={12}>
        <LastDateStatsSummary requestParams={requestParams} hasDrillDown={canDoDrillDown} />
      </Grid>

      <Grid item xs={12}>
        <ProductionCashInByMonth enableDateFilter requestParams={requestParams} />
      </Grid>

      <Grid item xs={12}>
        <GoalsProgressInTime requestParams={requestParams} hasDrillDown={canDoDrillDown} />
      </Grid>

      <Grid item xs={12}>
        <PlacementsTrends requestParams={requestParams} />
      </Grid>

      <Grid item xs={12}>
        <SendoutsTrends requestParams={requestParams} />
      </Grid>

      <Grid item xs={12}>
        <WeeklyActivityStatsSummary requestParams={requestParams} hasDrillDown={canDoDrillDown} />
      </Grid>

      <Grid item xs={12}>
        <WeeklyProductivityStatsSummary
          requestParams={requestParams}
          hasDrillDown={canDoDrillDown}
        />
      </Grid>

      <Grid item xs={12}>
        <WeeklyInventoryGrowthStatsSummary
          requestParams={requestParams}
          hasDrillDown={canDoDrillDown}
        />
      </Grid>

      <Grid item xs={12}>
        <PeopleReachedTrends requestParams={requestParams} />
      </Grid>

      <Grid item xs={12}>
        <InMailsTrends requestParams={requestParams} />
      </Grid>

      <Grid item xs={12}>
        <CallsTrends requestParams={requestParams} hasDrillDown={canDoDrillDown} />
      </Grid>

      <Grid item xs={12}>
        <PhoneTimeTrends requestParams={requestParams} hasDrillDown={canDoDrillDown} />
      </Grid>

      <Grid item xs={12}>
        <ActivityTrends requestParams={requestParams} hasDrillDown={canDoDrillDown} />
      </Grid>

      <Grid item xs={12}>
        <NotConnectedCallsTrends requestParams={requestParams} hasDrillDown={canDoDrillDown} />
      </Grid>

      <Grid item xs={12}>
        <NotConnectedPhoneTimeTrends requestParams={requestParams} hasDrillDown={canDoDrillDown} />
      </Grid>

      <Grid item xs={12}>
        <NotConnectedHourlyCallTrends requestParams={requestParams} hasDrillDown={canDoDrillDown} />
      </Grid>
    </Grid>
  );
};
